
import React from 'react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

type RequesterMessageProps = {
  message?: string;
};

export const RequesterMessage: React.FC<RequesterMessageProps> = ({ message }) => {
  if (!message) return null;
  
  return (
    <Alert className="bg-blue-50 border-blue-200 text-blue-800">
      <AlertTitle>Message du demandeur</AlertTitle>
      <AlertDescription className="italic">
        "{message}"
      </AlertDescription>
    </Alert>
  );
};
